var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFailureSign = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 59,
  height: 59,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 29.5,
  cy: 29.5,
  r: 29.5,
  fill: "#FF7A7A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.06 15.94a1.5 1.5 0 0 0-2.12 2.12L27.378 29.5l-11.44 11.44a1.5 1.5 0 0 0 2.122 2.12L29.5 31.622l11.44 11.44a1.5 1.5 0 1 0 2.12-2.122L31.622 29.5l11.44-11.44a1.5 1.5 0 0 0-2.122-2.12L29.5 27.378l-11.44-11.44Z",
  fill: "#fff"
})));
export { SvgFailureSign as ReactComponent };
export default __webpack_public_path__ + "6931998f2aca155e02e2471c84736240.svg";